import createFolderRequest from 'owa-service/lib/factory/createFolderRequest';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import folder from 'owa-service/lib/factory/folder';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import createFolderOperation from 'owa-service/lib/operation/createFolderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { trace } from 'owa-trace';
export default function createFavoritePersonasRootFolder() {
    return createFolderOperation({
        Header: getJsonRequestHeader(),
        Body: createFolderRequest({
            ParentFolderId: targetFolderId({
                BaseFolderId: distinguishedFolderId({ Id: 'root' }),
            }),
            Folders: [
                folder({
                    DisplayName: 'FavoritePersonas',
                    FolderClass: 'IPF.Note',
                }),
            ],
        }),
    }).then(function (response) {
        var responseMessage = response.Body.ResponseMessages
            .Items[0];
        if (responseMessage.ResponseClass === 'Error' &&
            responseMessage.ResponseCode === 'ErrorFolderExists') {
            trace.warn('Folder "FavoritePersonas" already exists');
            throw new Error('ErrorFolderExists');
        }
        else if (responseMessage.ResponseClass !== 'Success') {
            trace.error('Error creating "FavoritePersonas" ' + responseMessage.MessageText);
            throw responseMessage.MessageText;
        }
        return responseMessage.Folders[0].FolderId.Id;
    });
}
//# sourceMappingURL=createFavoritePersonasRootFolder.js.map